import React, { Component } from "react"
import { fields } from "../../../../fields"

import { Container, Form, FormGroup, FormField, Input, Radio, TextArea } from 'semantic-ui-react'

const departmentName = 'Audit'

class Audit extends Component {
    state = {}

    componentDidMount() {
        var savedDict = {}
        if (this.props.savedDict) {
            savedDict = this.props.savedDict
        } else {
            return
        }
        this.setState({
            stocktakeRequired: savedDict.stocktakeRequired,
            auditAppointmentDate: savedDict.auditAppointmentDate,
            consentLetterDate: savedDict.consentLetterDate,
            auditResignationLetterDate: savedDict.auditResignationLetterDate,
            lastAccountAuditedDate: savedDict.lastAccountAuditedDate,
            bankConfirmationStatus: savedDict.bankConfirmationStatus,
            remarks: savedDict.remarks,
            others: savedDict.others,
        })
    }

    handleChangeField = e => {
        if (this.props.viewOnly) {
            if (this.state[e.target.name] == null) {
                this.setState({ [e.target.name]: ""})
            }
            return
        }
        const { name, value } = e.target
        if (!getWritePermissionForField(name, this.props.permissions) && this.state[e.target.name] == null) {
            this.setState({ [e.target.name]: ""})
            return
        }   
        else if (!getWritePermissionForField(name, this.props.permissions)) return
        this.setState({ [name]: value }, () =>
            this.props.onStateChange(this.state)
        )
    }
    handleChangeStocktakeRequired = (e, { value }) => { 
        if (this.props.viewOnly) return
        if (!getWritePermissionForField('stocktakeRequired', this.props.permissions)) return
        this.setState({ stocktakeRequired: value }, () => 
            this.props.onStateChange(this.state)
        )
    }

    getFieldStyle(name) {
        if (!getReadPermissionForField(name, this.props.permissions)) {
            return { visibility: 'hidden' }
        }
        return { visibility: 'visible' }
    }

    render() {
        const { stocktakeRequired, auditAppointmentDate, consentLetterDate, auditResignationLetterDate, lastAccountAuditedDate, bankConfirmationStatus, remarks, others } = this.state
        return (
            <Container>
                <Form>
                    <FormGroup style={this.getFieldStyle('stocktakeRequired')} inline>
                        <label>Stock Take Required:</label>
                        <FormField control={Radio} label='Yes' value='yes' checked={stocktakeRequired === 'yes'} onChange={this.handleChangeStocktakeRequired}/>
                        <FormField control={Radio} label='No' value='no' checked={stocktakeRequired === 'no'} onChange={this.handleChangeStocktakeRequired}/>
                    </FormGroup>
                    <br />
                    <FormGroup widths={"equal"}>
                        <FormField style={this.getFieldStyle('auditAppointmentDate')} control={Input} type='date' label='Date of Audit Appointment' name='auditAppointmentDate' value={auditAppointmentDate} placeholder='Select date' onChange={this.handleChangeField}/>
                        <FormField style={this.getFieldStyle('consentLetterDate')} control={Input} type='date' label='Date of Consent Letter' name='consentLetterDate' value={consentLetterDate} placeholder='Select date' onChange={this.handleChangeField}/>
                        <FormField style={this.getFieldStyle('auditResignationLetterDate')}control={Input} type='date' label='Date of Audit Resignation Letter' name='auditResignationLetterDate' value={auditResignationLetterDate} placeholder='Select date' onChange={this.handleChangeField}/>
                        <FormField style={this.getFieldStyle('lastAccountAuditedDate')} control={Input} type='date' label='Date of Last Account Audited' name='lastAccountAuditedDate' value={lastAccountAuditedDate} placeholder='Select date' onChange={this.handleChangeField}/>
                    </FormGroup>
                    <FormField style={this.getFieldStyle('bankConfirmationStatus')} control={TextArea} rows='2' label='Status of Bank Confirmation' name='bankConfirmationStatus' value={bankConfirmationStatus} placeholder='' onChange={this.handleChangeField}/>
                    <FormField style={this.getFieldStyle('remarks')} control={TextArea} rows='2' label='Remarks' name='remarks' value={remarks} placeholder='' onChange={this.handleChangeField}/>
                    <FormField style={this.getFieldStyle('others')} control={Input} label='Others' name='others' value={others} placeholder='' onChange={this.handleChangeField}/>
                </Form>
            </Container>
        )
    }
}

function getWritePermissionForField(fieldName, permissions) {
    var key = ""
    for (let field of fields) {
        if (field.field === fieldName && field.departmentName === departmentName) {
            key = field.key
        }
    }
    for (let permission of permissions) {
        if (permission.key === key) {
            if (permission.write === false) {
            }
            return permission.write
        }
    }
}

function getReadPermissionForField(fieldName, permissions) {
    var key = ""
    for (let field of fields) {
        if (field.field === fieldName && field.departmentName === departmentName) {
            key = field.key
        }
    }
    for (let permission of permissions) {
        if (permission.key === key) {
            return permission.read
        }
    }
}

export default Audit